import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

// const accounts = msalInstance.getAllAccounts();
// if (accounts.length > 0) {
//   msalInstance.setActiveAccount(accounts[0]);
// }

// msalInstance.addEventCallback((event: any) => {
//   console.log(event);
//   if (
//     event.eventType === EventType.LOGIN_FAILURE ||
//     event.error?.errorCode === 'interaction_required'
//   ) {
//     // Auto-logout if interaction is required
//     console.warn('Login failed or interaction required. Logging out...');
//     msalInstance.logoutRedirect();
//   }
//
//   // set active account after redirect
//   if (event.eventType === EventType.LOGIN_SUCCESS && event?.payload?.account) {
//     const account = event?.payload?.account;
//     msalInstance.setActiveAccount(account);
//     console.log('Active account set:', account);
//   }
// });

// msalInstance
//   .handleRedirectPromise()
//   .then((response) => {
//     if (response) {
//       console.log('Login successful:', response);
//       msalInstance.setActiveAccount(response.account);
//     }
//   })
//   .catch((error) => {
//     console.error('Error handling redirect:', error);
//   });
//
// msalInstance
//   .acquireTokenSilent({
//     scopes: ['User.Read'],
//     account: msalInstance.getActiveAccount(),
//   })
//   .catch((error) => {
//     if (error.name === 'InteractionRequiredAuthError') {
//       console.warn('Silent acquisition failed, logging out...');
//       msalInstance.logoutRedirect();
//     } else {
//       console.error('Silent acquisition error:', error);
//     }
//   });

// handle auth redired/do all initial setup for msal
// msalInstance
//   .handleRedirectPromise()
//   .then((authResult) => {
//     // Check if user signed in
//     const account = msalInstance.getActiveAccount();
//     if (!account) {
//       // redirect anonymous user to login page
//       msalInstance.loginPopup(loginRequest);
//     }
//   })
//   .catch((err) => {
//     // TODO: Handle errors
//     console.log(err);
//   });

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
